import { SET_BIDS_PAYMENT_TYPE_TEXT_VALUE } from "../action";

export function resetPaymentTypeObject() {
  return (dispatch) => {
    dispatch({
      type: SET_BIDS_PAYMENT_TYPE_TEXT_VALUE,
      payload: {
        monthlyPayment: 0,
        cashDown: 0,
        finRate: 0,
        noOfMonths: 0,
        purchOptAmt: 0,
      },
    });
  };
}
